import { z } from 'zod'

const getErrorMessages = (val: string[] | string) => {
  return {
    required: `Pole ${val} jest wymagane.`,
    min: `Pole ${val[0]} musi być dłuższe niż ${val[1]}.`,
    max: `Pole ${val[0]} nie może być dłuższe niż ${val[1]}.`,
    invalid: `Pole ${val} zostało wypełnione niepoprawnie.`,
    checkbox: `Wyraź zgodę żeby przejść dalej.`,
    radio: `Zaznacz ${val} żeby przejść dalej.`,
    select: `Pole ${val} musi zostać wybrane`,
  }
}

const FormSchemas = {
  contact: z.object({
    name: z
      .string({ required_error: getErrorMessages('imię').required })
      .min(2, getErrorMessages(['imię', '2 znaki']).min),
    email: z
      .string({
        required_error: getErrorMessages('email').required,
      })
      .email({ message: getErrorMessages('email').invalid }),
    phoneNumber: z.string().optional(),
    message: z
      .string({ required_error: getErrorMessages('wiadomość').required })
      .min(10, getErrorMessages(['wiadomość', '10 znaków']).min),
    agree1: z
      .string()
      .includes('true', { message: getErrorMessages('').checkbox }),
  }),
}

export type TSchemasKey = keyof typeof FormSchemas

export type TContact = z.infer<(typeof FormSchemas)['contact']>

export default FormSchemas
